import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ManageRoleService } from "../../services/manage-role.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UserManagementUrls } from "src/app/user-management-routing";
import { ManageGroupService } from "../../services/manage-group.service";
import { ManageMappingService } from "../../services/manage-mapping.service";
import { SnackbarService } from "src/app/_service/message-service";
import { MenuRouteID } from "src/app/components/header/menu-item/nav-item";
import { UserInfoService } from "src/app/_services/userInfo.service";
import { VendorService } from "src/app/_services/vendor.services";

export interface User {
  tname: string;
  id: number;
}

@Component({
  selector: 'telio-users-mapping',
  templateUrl: './users-mapping.component.html',
  styleUrls: ['./users-mapping.component.scss']
})

export class UserMappingComponent implements OnInit, OnDestroy {

  //Role Mapping
  predecessorRole = [];
  successorRole = [];
  predecessorLabelRole = 'rbac.availableRoles';
  successorLabelRole = 'rbac.assignedRoles';
  drapDropDataRole = {};
  enableSubmit = false;
  //Group Mapping
  predecessor = [];
  successor = [];
  predecessorLabel = 'rbac.availableGroups';
  successorLabel = 'rbac.assignedGroups';
  drapDropData = {};
  @Input() userId;
  @Input() vendorId;
  @Input() routeID = null;
  
  availableTabs = [
    { id: MenuRouteID.TABS.ROLE_MAPPING, enable: false },
    { id: MenuRouteID.TABS.GROUP_MAPPING, enable: false }
  ];

  constructor(public translate: TranslateService,
    readonly roleService: ManageRoleService,
    private manageGroupService: ManageGroupService,
    readonly manageMappingService: ManageMappingService,
    private toastr: SnackbarService,
    private route: ActivatedRoute,
    private userInfoService: UserInfoService,
    private vendorservice: VendorService,
    readonly router: Router) { }

  ngOnInit(): void {
    this.getvendorinfobyvendorid();
    this.availableTabs = this.userInfoService.getPermittedTabs(+this.route.snapshot.paramMap.get('routeID'), this.availableTabs);
    let tabExists = this.availableTabs.filter(res => res.enable);
    !tabExists || tabExists.length == 0 ? this.toastr.info(this.translate.instant('unAuthorized')) : '';
  }

  tabClick(event) {
    event.index == 1 && this.getGroupsById()
  }

  getGroupsById() {
    this.manageGroupService.getGroupByUserId(this.userId).subscribe(
      (response) => {
        this.predecessor = response.available_groups.filter((role: any) => !!role);
        this.successor = response.groups.filter((role: any) => !!role);
      },
      err => {
        this.toastr.error(this.translate.instant('responseFailed'));
      }
    );
  }

  getRolesById() {
    this.roleService.getRolesByUserId(this.userId).subscribe(
      (response) => {
        this.predecessorRole = response.available_roles.filter((role: any) => !!role);
        this.successorRole = response.roles.filter((role: any) => !!role);
      },
      err => {
        this.toastr.error(this.translate.instant('responseFailed'));
      }
    );
  }

  //RoleMapping
  dragDropDataChangeRole(event: {}) {
    this.drapDropDataRole = !!event ? event : null;
    this.enableSubmit = (this.drapDropDataRole == this.successorRole) ? false : true;
  }

  // Group Mapping
  dragDropDataChange(event: {}) {
    this.drapDropData = !!event ? event : null;
    this.enableSubmit = (this.drapDropData == this.successor) ? false : true;
  }
  
  groupAssignSubmit() {
    !!this.drapDropData && this.manageMappingService.assignGroupToUserId(this.drapDropData, this.userId).subscribe((resp: any) => {
      this.updateMessages(resp, 'rbac.success');
    },err => {
      this.toastr.error(this.translate.instant('responseFailed'));
    }
    )
  }

  roleAssignSubmit() {
    !!this.drapDropDataRole && this.manageMappingService.assignRolesToUserId(this.drapDropDataRole, this.userId).subscribe((resp: any) => {
      this.updateMessages(resp, 'rbac.success');
    },err => {
      this.toastr.error(this.translate.instant('responseFailed'));
    }
    )
  }

  updateMessages(resp: any, msg: string) {
    !!resp ? this.toastr.success(this.translate.instant(msg)) : this.toastr.error(resp);
  }

  getvendorinfobyvendorid() {
    this.vendorservice.getvendorinfobyvendorid(this.vendorId).subscribe(res => {
      if (res.status_code != "500") {
        this.userId = res.user_id;
        this.getRolesById();
      }
    })
  }

  ngOnDestroy(): void { }
}
